import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { NavLink } from 'react-router-dom';
import * as Yup from 'yup';
import { Link, withRouter } from 'react-router-dom';
import { resetPassword } from '../services/authService';
import { checkField } from '../services/authService';
import image from "../components/Loader/image/loader.gif"
import Image from 'react-bootstrap/Image'

class ResetPassword extends React.Component {
    constructor() {
        super();
        this.state = {
           message: '',
           isLoader:false,
           isError:false
        }
    }

    handleSubmit = (values) => {
        this.setState({
            isLoader: true
        })
        resetPassword(values).then(
            
            (res) => {
                this.setState({
                    message: true,
                    isLoader:false
                })
               {/* setTimeout(() => {
                    this.props.history.push('/login');
                }, 5000);*/}
            }
        ).catch(err =>{
            this.setState({
                isError:true,
                isLoader:false
            })
          
           
        }
           )
    };

    render() {
        const initialValues = {
            email: ''
        }
        const loginSchema = Yup.object().shape({
            email: Yup.string()
                .required('Please input your email!')
                .email('Invalid email')
                .test('unique email', 'This email is not  exist',async (value) => {
                                    let error
                                    await checkField(value).then((res)=>{
                            
                                        if(res.data.exists===true){
                                           error=true
                                        }
                                        else if(res.data.exists===false){
                                          error=false
                                       }
                                        console.log(error)
                                    }).catch((err)=>{
                                        console.log(err)
                                        
                                    })
                                    return error
                                    
                                  }),
        });
        return (
            <div className='vh-70'>
                <div className='container p-4'>
                {
                    this.props.loading ?
                        <LoadingOutlined />
                        :
                        <div className='box-3 p-2 mt-2 mb-2'>
                        <Formik
                            initialValues={initialValues}
                            onSubmit={this.handleSubmit}
                            validationSchema={loginSchema}
                        >
                            <Form>
                                <div className="row">
                                    <div className='p-4'>
                                    <div className="">
                                        <h6 className="t-black"> Forgot your password or username? </h6>
                                    </div>
                                    <div className="">
                                       <span style={{fontSize:14}}className="" >Don't worry! Resetting your password is easy, just tell us the email address you're registered with.</span>
                                        <br></br>
                                        <hr></hr>
                                         
                                    </div>
                                    </div>
                                    <div className="col-md-12">
                                        <label className="col-md-14  h7">
                                            Enter your email:
                                           </label>
                                        <div className="col-md-14">
                                            <Field className="form-control" type="text" name="email" />
                                            <ErrorMessage name="email" className="text-danger" component="div" />
                                        </div>
                                    </div>

                                    <div className="col-md-12">
                                        <div className="col-md-14 pt-3">
                                            <button type="submit" className="w-100 btn btn-primary mr-2">
                                                Submit
                                            </button>
                                        </div>
                                    {
                                        this.state.message && (
                                            <div className="col-md-8 mt-2">
                                                <div className="col-md-10 p-2 bg-green text-black pl-1">
                                                     We have sent you a link to reset your password in your email, please follow the step shown in email.
                                                </div>
                                            </div>
                                        )
                                    }  
                                    {
                                        this.state.isError && (
                                            <div className="col-md-8 mt-2">
                                                <div className="col-md-10 p-2 bg-warning text-black pl-1">
                                                    Try again later we have encouter an error
                                                </div>
                                            </div>
                                        )
                                    }  
                                    
                                   
                                    </div>
                                </div>
                                { this.state.isLoader &&
                                         <div className="text-center">
                                            <div className="mt-3">
                                            <img className="w-50"src={image}></img>
                                            </div>
                                       
                                     </div>
                                    }
                            </Form>
                        </Formik>
                        <div>
                        <Link className='h7  mb-1 ml-4'to="/login" >Return back to Login and Signup</Link>
                            </div>
                        </div>
                }
                
               
           
               
            </div>
            </div>
            
        );
    }
}

export default ResetPassword;